import StackController from '../core/view-manager/stack-controller'
import NavigationAdapter from '../core/view-manager/navigation-adapter'
import ContentLoader from '../core/view-manager/content-loader'
import overlayView from '../core/view-manager/views/overlay-view'

// Registered view types, keyed by `data-open-in-view` value. Add views here.
const VIEW_REGISTRY = [['overlay-view', overlayView]]

// Hash → view type map for hash-driven overlays (e.g. { '#contact': 'contact' }).
// Empty by default; with no entries, navigating away simply closes the top view.
const HASH_TO_VIEW = {}

const bindHashRouting = (viewManager, swup) => {
	const handleHash = () => {
		const type = HASH_TO_VIEW[window.location.hash]

		if (!type) {
			if (viewManager.stack?.length) viewManager.closeTop({ fromPop: true })
			return
		}

		const top = viewManager.stack?.[viewManager.stack.length - 1]
		if (top?.view?.type === type) return

		viewManager.open({ type, url: null, static: true, suppressHistory: true })
	}

	// Make sure Swup doesn't hijack hash links
	document.addEventListener(
		'click',
		(e) => {
			const link = e.target.closest('a[href^="#"]')
			if (!link) return
			const href = link.getAttribute('href')
			if (!HASH_TO_VIEW[href]) return
			e.preventDefault()
			e.stopPropagation()
			if (window.location.hash !== href) {
				window.location.hash = href
			} else {
				handleHash()
			}
		},
		true,
	)

	window.addEventListener('hashchange', handleHash)

	// Swup anchor clicks might not trigger hashchange
	if (swup?.hooks?.on) {
		swup.hooks.on('link:anchor', handleHash)
	}

	handleHash()
}

// Phase 1 (construct): build the view manager and register views. No DOM query
// happens here — viewManager.mount() is called in Phase 2, after DOM ready.
export const initViewManager = (ctx) => {
	const adapter = new NavigationAdapter({ swup: ctx.swup })
	const contentLoader = new ContentLoader({ swup: ctx.swup })

	const viewManager = new StackController({
		rootSelector: '.js-views-manager',
		adapter,
		contentLoader,
		lenis: false,
		services: {
			componentsManager: ctx.componentsManager,
		},
	})

	VIEW_REGISTRY.forEach(([type, view]) => viewManager.register(type, view))

	document.addEventListener('view:close', () => viewManager.closeTop())
	bindHashRouting(viewManager, ctx.swup)

	ctx.viewManager = viewManager
}
